import {
  Card,
  CardContent,
  CardHeader,
  Fab,
  Grid,
  Tooltip,
} from "@mui/material";
import { InfoOperater, Operater } from "../../../index";
import AddIcon from "@mui/icons-material/Add";
import { useFormContext } from "react-hook-form";

const Index = () => {
  const { setValue, getValues, clearErrors } = useFormContext();
  const naziv = getValues("poslovniNazivPlatforme");
  const dodaj = () => {
    clearErrors("noviOperater");
    setValue("odabraniOperater", null);
    setValue("noviOperater", {
      id: 9999,
      naziv: { naziv: "" },
      adrese: [{ drzava: { naziv: "", oznaka: "", euSifra: "" } }],
      identifikatori: [
        {
          drzavaIzdavatelj: {
            oznaka: "",
            euSifra: "",
          },
          identifikacijskiBroj: "",
          vrstaIdentifikatora: { id: 3, opis: "TIN" },
        },
      ],
    });
  };
  return (
    <>
      <InfoOperater />
      <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
        <CardHeader
          title={"Poslovni naziv platforme (Platform business name): " + naziv}
          titleTypographyProps={{ variant: "h6" }}
          action={
            <Tooltip title={"Dodaj (Add)"}>
              <Fab size={"small"} aria-label="settings" onClick={dodaj}>
                <AddIcon />
              </Fab>
            </Tooltip>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Operater />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default Index;
